export const COUNTRIES = [
  "India", "United States", "United Kingdom", "Canada", "Australia",
  "Singapore", "United Arab Emirates", "Germany", "France", "Netherlands",
  "Ireland", "Japan", "South Korea", "Brazil", "Mexico", "Nigeria", "Global",
];

export const CURRENCIES = [
  { code: "INR", symbol: "₹", label: "INR · Indian Rupee" },
  { code: "USD", symbol: "$", label: "USD · US Dollar" },
  { code: "EUR", symbol: "€", label: "EUR · Euro" },
  { code: "GBP", symbol: "£", label: "GBP · British Pound" },
  { code: "AUD", symbol: "A$", label: "AUD · Australian Dollar" },
  { code: "CAD", symbol: "C$", label: "CAD · Canadian Dollar" },
  { code: "SGD", symbol: "S$", label: "SGD · Singapore Dollar" },
  { code: "AED", symbol: "د.إ", label: "AED · UAE Dirham" },
];

export const currencySymbol = (code) => {
  const found = CURRENCIES.find((c) => c.code === code);
  return found ? found.symbol : (code || "");
};
